module.exports = __webpack_public_path__ + "media/images/white_logo-8dd0666dcf35dbc6ae8d6f64f167c10d.png";